export const DOMAIN_NAME = "localpestindex.com";
export const DOMAIN_URL = "https://localpestindex.com/";
export const TRACKING_PHONE = "1-800-555-0199";
export const TRACKING_PHONE_HREF = "tel:+18005550199";

export type PropertyType = "single-family" | "apartment-condo" | "commercial";

export interface PropertyTypeOption {
  id: PropertyType;
  label: string;
  description: string;
}

export const PROPERTY_TYPES: PropertyTypeOption[] = [
  { id: "single-family", label: "Single-Family Home", description: "Detached house or duplex" },
  { id: "apartment-condo", label: "Apartment / Condo", description: "Multi-unit residential" },
  { id: "commercial", label: "Commercial Facility", description: "Business or industrial space" },
];

export type PestCategory = "standard" | "specialty";

export interface PestOption {
  id: string;
  label: string;
  category: PestCategory;
}

export const STANDARD_PESTS: PestOption[] = [
  { id: "ants", label: "Ants", category: "standard" },
  { id: "mice-rats", label: "Mice / Rats", category: "standard" },
  { id: "spiders", label: "Spiders", category: "standard" },
  { id: "cockroaches", label: "Cockroaches", category: "standard" },
  { id: "termites", label: "Termites", category: "standard" },
  { id: "crickets", label: "Crickets", category: "standard" },
  { id: "earwigs-silverfish", label: "Earwigs / Silverfish", category: "standard" },
];

export const SPECIALTY_PESTS: PestOption[] = [
  { id: "wasps-bees", label: "Wasps / Bees", category: "specialty" },
  { id: "bed-bugs", label: "Bed Bugs", category: "specialty" },
  { id: "raccoons-squirrels", label: "Raccoons / Squirrels", category: "specialty" },
  { id: "snakes", label: "Snakes", category: "specialty" },
  { id: "wild-animals", label: "Wild Animals", category: "specialty" },
];

export const ALL_PESTS = [...STANDARD_PESTS, ...SPECIALTY_PESTS];

export interface SymptomOption {
  id: string;
  label: string;
  weight: number;
}

export const SYMPTOM_OPTIONS: SymptomOption[] = [
  { id: "chewed-wood", label: "Chewed wood or damaged trim", weight: 2 },
  { id: "noise-walls", label: "Noise in walls or ceiling", weight: 2 },
  { id: "droppings", label: "Droppings found indoors", weight: 3 },
  { id: "grease-marks", label: "Grease marks along baseboards", weight: 2 },
  { id: "shed-skins", label: "Shed skins or molted shells", weight: 2 },
  { id: "mud-tubes", label: "Mud tubes on foundation", weight: 3 },
];

export type MetricStep = 1 | 2 | 3;

export type ResultType = "qualified" | "commercial" | "invalid_zip" | "specialty_license";

export type SeverityLevel = "low" | "moderate" | "high";
